import { render, staticRenderFns } from "./NewAdmissions.vue?vue&type=template&id=847a0426"
import script from "./NewAdmissions.vue?vue&type=script&lang=js"
export * from "./NewAdmissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports